import { Col } from "react-flexbox-grid";
import { getBase64 } from "helpers";
import Badge from "@material-ui/core/Badge";
import AvatarMaterial from "@material-ui/core/Avatar";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";

const SmallAvatar = styled(AvatarMaterial)`
  width: 22px;
  height: 22px;
  background: #fff !important;
  border: 2px solid #fff;
  padding: 4px;

  .MuiSvgIcon-root {
    padding: 4px;
  }
`;

const LargeAvatar = styled(AvatarMaterial)`
  width: 94px !important;
  height: 94px !important;
  padding: 4px;
`;

export const Avatar = ({ defaultValue, onChange = () => null }) => {
  const onUploadFile = async (evt) => {
    const data = evt.target.files[0];
    const image = await getBase64(data);
    onChange(image);
  };

  return (
    <Col md={12}>
      <Badge
        overlap="circle"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          <SmallAvatar>
            <input
              accept="image/*"
              className="dn"
              id="icon-button-file"
              type="file"
              onChange={onUploadFile}
            />
            <label htmlFor="icon-button-file">
              <IconButton
                color="secondary"
                aria-label="upload picture"
                component="span"
              >
                <PhotoCamera />
              </IconButton>
            </label>
          </SmallAvatar>
        }
      >
        <LargeAvatar alt="profile" src={defaultValue} />
      </Badge>
    </Col>
  );
};
